/**
 * 异常停车记录
 */
import React from "react";

import { Input, Row, Col, Select, DatePicker } from "antd";
import PageLayout from "../ui/PageLayout";
import moment from "moment";
const { RangePicker } = DatePicker;

class VehicleParkInfo extends React.Component {
  columns = [
    {
      title: "时间",
      dataIndex: "eventTime",
      width: "15%",
    },
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: "20%",
    },
    {
      title: "事件",
      dataIndex: "event",
      width: "25%",
    },
    {
      title: "备注",
      dataIndex: "details",
      width: "40%",
    },
  ];

  state = {
    loadData: "",
    queryData: { type: 1 },
  };

  typeChange = (val) => {
    console.log("typeChange", val);
    let queryData = this.state.queryData;
    queryData["type"] = val;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  periodChange = (val, valstr) => {
    console.log("periodChange", valstr);
    let queryData = this.state.queryData;

    queryData["start"] = valstr[0];
    queryData["end"] = valstr[1];
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  plateNoSearch = (value) => {
    let queryData = this.state.queryData;
    queryData["plateNo"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={3}>
                <Select
                  value={this.state.queryData.type}
                  onChange={this.typeChange}
                >
                  <Select.Option value={1}>高频进场</Select.Option>
                  <Select.Option value={2}>车辆过夜</Select.Option>
                </Select>
              </Col>
              <Col span={6}>
                <RangePicker
                  onChange={this.periodChange}
                  ranges={{
                    昨天: [moment().subtract(1, "days"), moment()],
                    本周: [moment().startOf("week"), moment().endOf("week")],
                    上周: [
                      moment()
                        .week(moment().week() - 1)
                        .startOf("week"),
                      moment()
                        .week(moment().week() - 1)
                        .endOf("week"),
                    ],
                    本月: [moment().startOf("month"), moment().endOf("month")],
                  }}
                  format="YYYY-MM-DD"
                />
              </Col>
              <Col span={3}>
                <Input.Search
                  placeholder="车牌号"
                  onSearch={this.plateNoSearch}
                  enterButton
                />
              </Col>
            </Row>
          }
          rowKey="id"
          url="/barrier/vehicleParkWarn/query"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
      </div>
    );
  }
}

export default VehicleParkInfo;
